module.exports = __webpack_public_path__ + "img/SER.bd8a4e7f.png";